import { useMemo } from 'react'
import { useTime } from 'core/time'

const useToday = () => {
  const { getToday } = useTime()
  return useMemo(getToday, [getToday])
}
export default useToday
